import React from 'react';
import {Box, Typography, FormControlLabel, Stack, Switch, Divider} from "@mui/material";
import {APIProvider} from '@vis.gl/react-google-maps';
import SolarMap from "./SolarMap.tsx";
import type {Coordinates} from "../../types/solar";

export type MapCenter = {
    coordinates: Coordinates,
    doesMarkerEqualsLocation: boolean
}

type SolarGoogleMapProps = {
    location: { lat: number, lng: number };
    apiKey: string;
    markerPosition: MapCenter;
    projectId?: number;
    currentModuleCount?: number;
    setModuleCount?: (count: number) => void;
    aspectRatio?: string;
    showBox?: boolean;
    isDraggable?: boolean;
    // activeSegment: any;
    // setActiveSegment: (segment: any) => void;
    // handleMapClick: (latLng: google.maps.LatLng) => void;
    // overlayUrl: string | null;
    // overlayBounds: google.maps.LatLngBoundsLiteral | null;
};

const SolarGoogleMap: React.FC<SolarGoogleMapProps> = ({
        location,
        apiKey,
        markerPosition,
        projectId,
        currentModuleCount,
        setModuleCount,
        aspectRatio,
        showBox = false,
        isDraggable = false
        // activeSegment,
        // setActiveSegment,
        // handleMapClick,
        // overlayUrl,
        // overlayBounds,
    }) => {
        const [showHiddenPanels, setShowHiddenPanels] = React.useState(true);
        // @TODO: Enable/Remove after overlay is implemented
        const enableSolarAreaSwitch = false;

        // if (projectData) {
        //     await getGeoJson(projectData.projectId).then((geoJson) => {
        //         console.log('Fetched GeoJSON:', geoJson);
        //     }
        // }

        // const handleMapLoad = useCallback((map: google.maps.Map) => {
        //     mapRef.current = map;
        //     map.overlayMapTypes.insertAt(0, new google.maps.ImageMapType({
        //         getTileUrl: (coord, zoom) => {
        //             return `${convertedOverlayUrl}&x=${coord.x}&y=${coord.y}&z=${zoom}`;
        //         },
        //         tileSize: new google.maps.Size(256, 256),
        //     }));
        // }, [convertedOverlayUrl]);

        return (
            <Box sx={{position: "relative", height: "calc(100%)"}}>
                <Box sx={{width: "100%", height: "calc(100%)", aspectRatio: aspectRatio}}>
                    <APIProvider apiKey={apiKey}>
                        <SolarMap
                            location={location}
                            markerPosition={markerPosition}
                            projectId={projectId}
                            currentModuleCount={currentModuleCount}
                            isDraggable={isDraggable}
                            setModuleCount={setModuleCount}
                            showHiddenPanels={showHiddenPanels}
                        />
                    </APIProvider>
                </Box>
                {showBox &&
                    <Box
                        sx={{
                            position: "absolute",
                            bottom: 20,
                            left: 10,
                            backgroundColor: "white",
                            borderRadius: 3,
                            p: 1,
                            width: "calc(80% - 5px)",
                        }}
                    >
                        <Stack
                            spacing={1}
                            divider={
                                <Divider
                                    // sx={{ borderColor: 'var(--mui-palette-primary-contrastText)' }}
                                    flexItem
                                />
                            }
                        >
                            {enableSolarAreaSwitch &&
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={false}
                                            // onChange={(e) => setShowSolarAreas(e.target.checked)}
                                            sx={{
                                                "& .MuiSwitch-switchBase.Mui-checked": {
                                                    color: "#041b2b",
                                                },
                                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                                    {
                                                        backgroundColor: "#d0d0d0",
                                                    },
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography
                                            sx={{
                                                fontFamily: '"Sora", sans-serif',
                                                fontSize: 16,
                                                color: "#1d1d1d",
                                            }}
                                        >
                                            Sonnenflächen anzeigen
                                        </Typography>
                                    }
                                />
                            }
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={showHiddenPanels}
                                        onChange={(e) => {
                                            setShowHiddenPanels(e.target.checked)
                                        }}
                                        sx={{
                                            "& .MuiSwitch-switchBase.Mui-checked": {
                                                color: "#041b2b",
                                            },
                                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                                {
                                                    backgroundColor: "#d0d0d0",
                                                },
                                        }}
                                    />
                                }
                                label={
                                    <Typography
                                        sx={{
                                            fontFamily: '"Sora", sans-serif',
                                            fontSize: 16,
                                            color: "#1d1d1d",
                                        }}
                                    >
                                        Alle platzierbaren Solarpanels anzeigen
                                    </Typography>
                                }
                            />
                        </Stack>
                    </Box>
                }
            </Box>
        )
            ;
    }
;

export default SolarGoogleMap;